import React, { createElement } from 'react'

//Node Modules
import { domToReact, HTMLReactParserOptions, DomElement } from 'html-react-parser'

//Components
import CopyCode from 'components/xis/CopyCode'

// Util
import { hasClass } from '../conditions'

const textOnlyOptions:HTMLReactParserOptions = {
  replace: (node:DomElement) => {
    if (
      hasClass(node, 'xis-calloutAnchor') ||
      hasClass(node, 'xisDoc-calloutAnchor') ||
      hasClass(node, 'xis-columnRuler')
    ) {
      return <React.Fragment />
    }

    return node
  }
}

const getText = (accum: string, node: JSX.Element): string => {
  if (Array.isArray(node)) {
    return (node as JSX.Element[]).map(n => getText(accum, n)).join()
  } else if (typeof node === "string") {
    return `${accum}${node}`
  }
  if (node === null) return ''
  const children = node.props && node.props.children

  if (children === undefined) {
    return accum
  } else if (typeof children === "string") {
    return `${accum}${children}`
  } else if (Array.isArray(children)) {
    const array = children as JSX.Element[]

    return array.map(n => getText(accum, n)).join('')
  } else {
    return getText(accum, children)
  }
}

export default (node:any, params:any, options:any) => {
  const children = node.children

  const domElems = domToReact(children, textOnlyOptions) as JSX.Element[]

  const text = domElems.map(e => getText("", e)).join('').trim()

  return createElement(
    CopyCode as React.FunctionComponent,
    {
      text,
      // code: domToReact(children, options)
      code: domToReact(children, options)
    } as any, null
  )
}